module.exports = __webpack_public_path__ + "static/teleco_22-4e86e9519bcfc0ff2b5bf42d47930cff.jpg";